import { render, staticRenderFns } from "./centerUserBalance.vue?vue&type=template&id=62f0c07e&scoped=true&"
import script from "./centerUserBalance.vue?vue&type=script&lang=js&"
export * from "./centerUserBalance.vue?vue&type=script&lang=js&"
import style0 from "./centerUserBalance.vue?vue&type=style&index=0&id=62f0c07e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f0c07e",
  null
  
)

export default component.exports